export class FeedbackConfig {
  type: FeedbackType;
  modal: FeedbackModal;
  extraFeedbackValues?: any[];
}

export enum FeedbackType {
  JOBOFFER = "job-offer",
  EXPERIENCE = "experience",
}

export class FeedbackModal {
  title: string;
  subTitle?: string;
  mainText: string;
  closeLabel?: string;
  showFooter?: boolean;
  avoidClose?: boolean;
  modalClass?: string;
  onSuccess?: () => any;
  onError?: () => any;
}
